import auth from './auth';
import list from './list';
import modal from './modal';
import form from './form'

const rootReducer = {
  auth,
  list,
  modal,
  form
};

export default rootReducer;
